import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TypingIndicatorEvent } from '../../models';

@Component({
  selector: 'app-typing-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './typing-indicator.html',
  styleUrls: ['./typing-indicator.scss'],
})
export class TypingIndicatorComponent {
  @Input() indicators: TypingIndicatorEvent[] = [];

  get label(): string {
    if (!this.indicators.length) return '';
    const names = this.indicators.map((i) => i.senderDisplayName);
    if (names.length === 1) return `${names[0]} is typing...`;
    if (names.length === 2) return `${names[0]} and ${names[1]} are typing...`;
    return `${names[0]} and ${names.length - 1} others are typing...`;
  }
}
